<template>
  <div class="addstandingBook">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">审计报告问题整改表单</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">审计报告审批流程</div>
        <blank height="7"> </blank>
        <a-button
          class="detial-top-btn"
          type="primary"
          icon="printer"
          v-if="Form.state == 2"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @tabClick="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">审计报告问题整改表单创建</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照文本要求添加表单，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">报告表单</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label">审计机构<span class="required">*</span> </span>
            <a-tooltip placement="topLeft" :title="Form.auditOrgName">
              <div>
                <a-input
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.auditOrgName"
                  disabled
                />
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">被审计单位<span class="required">*</span> </span>
            <a-tooltip placement="topLeft" :title="Form.auditedOrgName">
              <div>
                <a-input
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.auditedOrgName"
                  disabled
                />
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item label="审计报告文号">
            <a-input
              class="w300"
              placeholder="请输入审计报告文号"
              v-model="Form.auditReportNumber"
              :disabled="disabled"
              @change="eightyfive('auditReportNumber', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">审计类型<span class="required">*</span> </span>
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.auditType"
              :disabled="disabled"
            >
              <a-select-option
                v-for="item in auditTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >审计报告时间<span class="required">*</span>
            </span>
            <a-date-picker
              allowClear
              class="w300"
              v-model="Form.auditReportTime"
              valueFormat="YYYY-MM-DD"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">资料等级<span class="required">*</span> </span>
            <a-select
              class="w300"
              placeholder="请选择资料等级"
              v-model="Form.secretLevel"
              disabled
            >
              <a-select-option :value="100"> 重要 </a-select-option>
              <a-select-option :value="10"> 普通 </a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="备注">
            <a-input
              placeholder="请添加"
              v-model="Form.remark"
              :disabled="disabled"
              class="w500"
              type="textarea"
              :auto-size="{ minRows: 4, maxRows: 6 }"
              @change="eightyfive('remark', 200)"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <!-- 附件 -->
      <StandBookTable
        :disabled="disabled"
        :resDetail="problemRectifications"
      ></StandBookTable>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/auditReport/details?id="
      skipPageReqFlag="/standingBookDetails"
    >
      <div class="print-title">审计报告问题整改督导台账</div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="审计机构" :span="1.5">
              {{ Form.auditOrgName }}
            </a-descriptions-item>
            <a-descriptions-item label="被审计单位" :span="1.5">
              {{ Form.organizationName }}
            </a-descriptions-item>
            <a-descriptions-item label="	审计报告文号" :span="1.5">
              {{ Form.auditReportNumber }}
            </a-descriptions-item>
            <a-descriptions-item label="审计类型" :span="1.5">
              {{ getByTypeName(Form.auditType, auditTypeList) }}
            </a-descriptions-item>
            <a-descriptions-item label="审计报告时间" :span="1.5">
              {{ Form.auditReportTime }}
            </a-descriptions-item>
            <a-descriptions-item label="	资料等级" :span="1.5">
              {{ Form.secretLevel == 100 ? '重要' : '一般' }}
            </a-descriptions-item>
            <a-descriptions-item label="备注" :span="3">
              {{ Form.remark }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns2"
            :data-source="problemRectifications"
            :row-key="(record) => record.id"
            bordered
          >
            <div slot="order" slot-scope="text, record, index">
              {{ index + 1 }}
            </div>
            <div slot="problemNature" slot-scope="text">
              {{ text == 1 ? '一般' : '严重' }}
            </div>
            <div slot="rectification" slot-scope="text">
              {{ text == 1 ? '是' : '否' }}
            </div>
            <div slot="rectificationSituation" slot-scope="text">
              {{ text == 1 ? '已整改' : '未整改' }}
            </div>
          </a-table>
        </div>

        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
import {
  updateAuditReportRectification,
  AuditReportRectificationDetial,
  addAuditReportRectification
} from './api/api'
import StandBookTable from './components/standBookTable.vue'
export default {
  data() {
    return {
      confirmLoading: false,
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      problemRectifications: [],
      id: '',
      dateFormat: 'YYYY-MM-DD',
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 审批流部分
      isPrint: false, // 打印弹窗
      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      columns2: [
        {
          title: '序号',
          dataIndex: 'order',
          key: 'order',
          scopedSlots: { customRender: 'order' }
        },
        {
          title: '问题性质',
          dataIndex: 'problemNature',
          key: 'problemNature',
          align: 'left',
          scopedSlots: { customRender: 'problemNature' }
        },
        {
          title: '问题描述',
          dataIndex: 'problemDesc',
          key: 'problemDesc',
          align: 'left'
        },
        {
          title: '问题详细说明',
          dataIndex: 'problemExplain',
          key: 'problemExplain',
          align: 'left'
        },
        {
          title: '是否整改',
          dataIndex: 'rectification',
          key: 'rectification',
          align: 'left',
          scopedSlots: { customRender: 'rectification' }
        },
        {
          title: '整改完成时间',
          dataIndex: 'rectificationTime',
          key: 'rectificationTime',
          align: 'left'
        },
        {
          title: '整改情况',
          dataIndex: 'rectificationSituation',
          key: 'rectificationSituation',
          align: 'left',
          scopedSlots: { customRender: 'rectificationSituation' }
        },
        {
          title: '未整改原因',
          dataIndex: 'rectificationReason',
          key: 'rectificationReason',
          align: 'left'
        }
      ],
      formDTOList: [],
      pIsedit: ''
    }
  },
  components: {
    StandBookTable,
    approvalSubmission,
    approvalChart
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.organizeList, // 组织机构树
      organizationId: (state) => state.app.organizationId, // 当前用户部门id
      auditTypeList: (state) => state.bytype.auditTypeList // 	审计类型
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    this.getorganizeListFn()
    this.getauditType()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    if (this.id) {
      this.load()
    } else {
      this.Form.auditOrgId = this.$route.query.auditOrgId
      this.Form.auditedOrgId = this.$route.query.auditedOrgId
      this.Form.auditOrgName = this.$route.query.auditOrgName
      this.Form.auditedOrgName = this.$route.query.auditedOrgName
      this.Form.secretLevel = 100
    }
  },
  methods: {
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '审计报告-' +
        this.Form.organizationName +
        this.$printFormatDate(new Date())
    },
    ...mapActions(['getorganizeListFn', 'getauditType']),
    load() {
      AuditReportRectificationDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.problemRectifications = this.Form.problemRectifications
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        }
      })
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.load()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    goback() {
      this.$router.push('/standingBook')
    },
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.Form.draft = 2
      } else {
        this.pIsedit = '2'
        this.Form.draft = 1
      }
      if (!this.Form.auditType) {
        this.$message.error('请选择审计类型')
        return false
      }
      if (!this.Form.auditReportTime) {
        this.$message.error('请选择审计报告时间')
        return false
      }
      if (!this.Form.secretLevel) {
        this.$message.error('请选择资料等级')
        return false
      }
      if (this.problemRectifications.length == 0) {
        this.$message.error('请添加问题整改台账')
        return false
      }
      this.confirmLoading = true
      this.saveFormFn('保存')
    },

    submitFn() {
      if (!this.Form.auditType) {
        this.$message.error('请选择审计类型')
        return false
      }
      if (!this.Form.auditReportTime) {
        this.$message.error('请选择审计报告时间')
        return false
      }
      if (!this.Form.secretLevel) {
        this.$message.error('请选择资料等级')
        return false
      }
      if (this.problemRectifications.length == 0) {
        this.$message.error('请添加问题整改台账')
        return false
      }
      if (this.Form.state > 0) {
        this.Form.draft = 2
        this.saveFormFn('添加')
      } else {
        this.$confirm({
          title: '确定提交吗?',
          okType: 'danger',
          onOk: () => {
            this.Form.draft = 2
            this.saveFormFn('添加')
          }
        })
      }
    },
    saveFormFn(type) {
      this.Form.problemRectifications = this.problemRectifications
      // this.Form.appId = this.$route.meta.appId
      this.Form.appId = this.$route.meta.appId
      this.Form.skipPageReqFlag = '/standingBookDetails'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        updateAuditReportRectification(this.Form).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.Form.state > 0) {
                this.load()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.Form.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        this.Form.businessId = this.$route.query.businessId
        addAuditReportRectification(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            this.loading = false
            this.confirmLoading = false
            if (this.Form.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.load()
            }
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addstandingBook {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
// 打印内容不能嵌套写样式

.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>

<style scoped src="@/assets/css/printModal.css"></style>



// WEBPACK FOOTER //
// src/views/standingBook/details.vue